import { Heart } from "lucide-react";
import { useWishlist } from "../context/WishlistContext";

/**
 * Heart toggle button. Reuses the WishlistContext so state is shared across pages.
 *
 * Props:
 *   productId    — string (required)
 *   size         — "sm" | "md" (default md)
 *   className    — extra wrapper classes
 *   showTooltip  — bool (defaults true)
 */
const WishlistButton = ({ productId, size = "md", className = "", showTooltip = true }) => {
  const { isIn, toggle } = useWishlist();
  const active = isIn(productId);
  const dim = size === "sm" ? "w-7 h-7" : "w-9 h-9";
  const icon = size === "sm" ? "w-4 h-4" : "w-5 h-5";

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(productId);
      }}
      title={showTooltip ? (active ? "Remove from wishlist" : "Save to wishlist") : undefined}
      data-testid={`wishlist-btn-${productId}`}
      className={`${dim} flex items-center justify-center rounded-full transition-colors ${
        active
          ? "bg-[#D62828] text-white"
          : "bg-black/60 text-white/80 hover:bg-black/85 hover:text-white"
      } ${className}`}
    >
      <Heart className={`${icon} ${active ? "fill-current" : ""}`} />
    </button>
  );
};

export default WishlistButton;
